import { ComprehensiveAnalysisPage } from './ComprehensiveAnalysisPage';
export default ComprehensiveAnalysisPage;
